module.exports = __webpack_public_path__ + "img/cracker-banana-majuscules.f557a638.jpg";